module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/home-2-bg-328a9aeb0232721f2ba5aab052c89fa6.svg";